webpackJsonp([246384609461072],{

/***/ 463:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/RQG.d26af47e.png";

/***/ }),

/***/ 464:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/closetroulette.71cff3be.png";

/***/ }),

/***/ 465:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/color.91cd6009.png";

/***/ }),

/***/ 467:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/imggallery.84d296ef.png";

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/lambdanotes.eeea8681.png";

/***/ }),

/***/ 469:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/landingpage.727668b0.png";

/***/ }),

/***/ 470:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/tribute.859904d3.png";

/***/ }),

/***/ 471:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/wikiviewer.1366c449.png";

/***/ }),

/***/ 205:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	__webpack_require__(301);
	
	var _tribute = __webpack_require__(470);
	
	var _tribute2 = _interopRequireDefault(_tribute);
	
	var _lambdanotes = __webpack_require__(468);
	
	var _lambdanotes2 = _interopRequireDefault(_lambdanotes);
	
	var _closetroulette = __webpack_require__(464);
	
	var _closetroulette2 = _interopRequireDefault(_closetroulette);
	
	var _imggallery = __webpack_require__(467);
	
	var _imggallery2 = _interopRequireDefault(_imggallery);
	
	var _landingpage = __webpack_require__(469);
	
	var _landingpage2 = _interopRequireDefault(_landingpage);
	
	var _color = __webpack_require__(465);
	
	var _color2 = _interopRequireDefault(_color);
	
	var _wikiviewer = __webpack_require__(471);
	
	var _wikiviewer2 = _interopRequireDefault(_wikiviewer);
	
	var _RQG = __webpack_require__(463);
	
	var _RQG2 = _interopRequireDefault(_RQG);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PortfolioPage = function PortfolioPage() {
	  return _react2.default.createElement(
	    'div',
	    { className: 'portfolio' },
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _closetroulette2.default, alt: 'closet roulette web app screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Closet Roulette'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A digital closet that enables users to upload images of their outfits and transforms them into virtual attire.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'JavaScript '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'React '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Node '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Express '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'MongoDB'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Stripe API'
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'SendGrid API'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://www.closetroulette.com/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _lambdanotes2.default, alt: 'lambda notes web app screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Lambda Notes'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A Full Stack note taking web application that enables authenticated users to manage their notes.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'JavaScript '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'React '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Node '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Express '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'MongoDB'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/lambdanotes',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://lambda-notes-app.netlify.com/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', {
	          src: _RQG2.default,
	          alt: 'random quote generator project webpage screenshot'
	        })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Random Quote Generator'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A Random Quote Generator built using AJAX utilizing a JSON-encoded, third-party external API to fetch quote data. Also integrated Twitter Web Intents to enable users tweet out quotes.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'JavaScript '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'AJAX '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Fetch API '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Quotes API'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/RQG',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://nedu.github.io/RQG/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _tribute2.default, alt: 'tribute webpage screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Responsive Website'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Simple single page reponsive tribute website to Superman'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'HTML5 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'CSS3 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Bootstrap 4 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Responsive Design'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/Tribute-Page',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://nedu.github.io/Tribute-Page/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _imggallery2.default, alt: 'image gallery screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Image Gallery'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Simple image gallery'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'HTML5 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'CSS3 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Responsive Design'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/ImageGallery',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://nedu.github.io/ImageGallery/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _landingpage2.default, alt: 'landing page screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Landing Page'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Simple landing page'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'HTML5 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'CSS3 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Responsive Design '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Bootstrap 3'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/LandingPage',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://nedu.github.io/LandingPage/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _color2.default, alt: 'color game app screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'Color Game'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Simple Color Game where you guess a color based on a given RGB value'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'HTML5 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'CSS3 '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Responsive Design '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'JavaScript'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/ColorGame',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://nedu.github.io/ColorGame/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: 'portfolio__project' },
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-demo' },
	        _react2.default.createElement('img', { src: _wikiviewer2.default, alt: 'wiki viewer web app screenshot' })
	      ),
	      _react2.default.createElement(
	        'div',
	        { className: 'portfolio__project-description' },
	        _react2.default.createElement(
	          'h3',
	          null,
	          'WikiSearch'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'A Wikipedia article previewer built using React that utilizes the MediaWiki API to search for the user\'s query.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'React.js '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Webpack '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'JavaScript '
	          ),
	          _react2.default.createElement(
	            'span',
	            { className: 'skilltag' },
	            'Wikipedia API'
	          )
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://github.com/Nedu/WikiSearch',
	            target: '_blank'
	          },
	          'GitHub'
	        ),
	        _react2.default.createElement(
	          'a',
	          {
	            className: 'skilltag demo',
	            href: 'https://nedu.github.io/WikiSearch/',
	            target: '_blank'
	          },
	          'View Live'
	        )
	      )
	    )
	  );
	};
	
	exports.default = PortfolioPage;
	module.exports = exports['default'];

/***/ }),

/***/ 301:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portfolio-js-03207f5dd4c6157f31e8.js